import {DailyRewardType} from '@/stores/DailyRewardsStore/DailyRewardsStore.constants';
import {Reward} from '@/stores/DailyRewardsStore/DailyRewardsStore.types';

export const REWARDS_MOCK: Array<Reward> = [
  {
    day: 1,
    wasReceived: true,
    reward: {
      type: DailyRewardType.Gems,
      value: 500,
    },
  },
  {
    day: 2,
    wasReceived: true,
    reward: {
      type: DailyRewardType.Gems,
      value: 1500,
    },
  },
  {
    day: 3,
    wasReceived: false,
    reward: {
      type: DailyRewardType.EnergyRecharge,
      value: 2,
    },
  },
  {
    day: 4,
    wasReceived: false,
    reward: {
      type: DailyRewardType.Gems,
      value: 2000,
    },
  },
  // {
  //   day: 4,
  //   wasReceived: false,
  //   reward: {
  //     type: DailyRewardType.Gift,
  //   },
  // },
];
